import { IBaseMapper } from '@/bundles/App/interfaces';
import { IAdClient } from '@/bundles/Ad/interfaces';
import AdClient from '@/bundles/Ad/models/AdClient';

export default class AdClientToMapper implements IBaseMapper<IAdClient> {
  mapToModel (data: IAdClient): IAdClient {
    return new AdClient(data);
  }
}
